import { render, staticRenderFns } from "./ShopMenuItemServiceSinglePackage.vue?vue&type=template&id=e9f60866&"
import script from "./ShopMenuItemServiceSinglePackage.vue?vue&type=script&lang=ts&"
export * from "./ShopMenuItemServiceSinglePackage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports